var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "31_\u9E9F\u5EB7\u5546\u57CE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3,10.26A4.34,4.34,0,0,0,49,6.2H15a4.36,4.36,0,0,0-4.34,4.06L8,53.19a4.34,4.34,0,0,0,4.34,4.61H51.66A4.34,4.34,0,0,0,56,53.19ZM12.35,53.46,15,10.54H49l2.69,42.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.23,15.31a2,2,0,0,0-2.17,1.74c0,4-4.06,7.24-9.05,7.24S23,21,23,17.05a2,2,0,0,0-2.17-1.74,2,2,0,0,0-2.16,1.74c0,5.91,6,10.72,13.39,10.72S45.41,23,45.41,17.05A2,2,0,0,0,43.23,15.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74,43.14a5.65,5.65,0,0,0-1.67-4,5.71,5.71,0,0,0-4-1.75L26.21,37.2A5.78,5.78,0,0,0,26,48.76L37.77,49a6.2,6.2,0,0,0,6-5.86ZM23.23,45.35a3.79,3.79,0,0,1-.62-3.81c.45-1.31,2-2.29,4.45-2.36h4.67l-.05,7.72H27a5.58,5.58,0,0,1-3.77-1.55Zm18.5-1.61a.56.56,0,0,1-.49-.61,2.78,2.78,0,0,0-.93-2.31,3.22,3.22,0,0,0-2.3-1l-3.75.08c-.4,0-.48-.26-.48-.49a.42.42,0,0,1,.39-.38H38a4,4,0,0,1,3,1.27,4.13,4.13,0,0,1,1.19,3,.54.54,0,0,1-.45.43Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoper);
export default __webpack_public_path__ + "static/media/shoper.dea0398d.svg";
export { ForwardRef as ReactComponent };